import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Setting} from '../models/setting.model';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    constructor(private httpClient: HttpClient) {
    }

    /**
     * Get all app settings
     * @returns Observable<Setting[]>
     */
    getAllSettings(): Observable<Setting[]> {
        return this.httpClient.get<Setting[]>(
            environment.baseUrl + "/settings"
        );
    }
}
